import { routerReducer } from "@ngrx/router-store";
import { User } from "../beans/User";
import { ReferenceDataReducer } from "./reference-data/reference-data.reducers";
import { RouterState } from "./router/router.model";
import { UserReducer } from "./user/user.reducers";

export interface AppModel {
    [RootKeys.router]: RouterState
    [RootKeys.user_store]: User,
    [RootKeys.reference_data]: Record<string, any>
}

export enum RootKeys {
    router = 'router',
    user_store = 'user_store',
    reference_data = 'reference_data',
}

export const RootReducers = {
    [RootKeys.router]: routerReducer,
    [RootKeys.user_store]: UserReducer,
    [RootKeys.reference_data]: ReferenceDataReducer,
}